import * as React from 'react'
import * as ReactDOM from "react-dom";
import {CallJs} from "./types";
import ReCAPTCHA from "react-google-recaptcha";

type ReCaptchaProps = {
	sitekey: string
}

export const SbRecaptcha: CallJs<ReCaptchaProps> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)
	ReactDOM.render(
		<ReCAPTCHA
			sitekey={params.sitekey}
			onChange={() => {}}
		/>,
		div
	)
}



// WEBPACK FOOTER //
// ./src/lib/recaptcha.tsx